import {combineReducers, configureStore} from '@reduxjs/toolkit';
import {persistReducer, persistStore} from 'redux-persist';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';
import storage from 'redux-persist/lib/storage';
import DrugInventorySlice from './Slice/drugInventorySlice';
import Fertility from './Slice/fertilitySlice';
import InPatientReducer from './Slice/inPatientScheduleSlice';
import UserSlice from './Slice/rootSlice';

const persistConfig = {
  key: 'root',
  storage,
  stateReconciler: autoMergeLevel2
};

const reducer = combineReducers({
  counter: UserSlice,
  drugInventory: DrugInventorySlice,
  inPatientSchedule: InPatientReducer,
  fertility: Fertility
});

const persistedReducer = persistReducer(persistConfig, reducer);

const store = configureStore({
  reducer: persistedReducer
});

const persistor = persistStore(store);

export default {store, persistor};
